import { LitElement, html, nothing, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';
import { AtlBreadcrumbClickEvent, AtlBreadcrumbItemProps } from './props';

import * as TagNames from './breadcrumbs.tagnames.ts';
import { AtlAriaIconProps } from '../icon/icon.props.ts';
import { classMap } from 'lit/directives/class-map.js';
import { ButtonEnums } from '../button';
import { AtlButtonTemplate } from '../button/button.component.ts';
import { getGlobalStyleSheets } from '../../global-styles';
import breadcrumbsStyles from './breadcrumbs.scss?inline';


@customElement(TagNames.BreadCrumbsItem)
export class AtlBreadcrumbItem extends LitElement implements AtlBreadcrumbItemProps {
    declare internalId: string;
    declare internalClassName?: string;
    declare clickable?: boolean;
    declare iconName?: string;
    declare active?: boolean;

    static properties = {
        internalId: { type: String },
        internalClassName: { type: String },
        clickable: { type: Boolean },
        active: { type: Boolean },
        iconName: { type: String, attribute: 'icon-name' }
    }

    static styles = [
        ...getGlobalStyleSheets(),
        unsafeCSS(breadcrumbsStyles)
    ]

    renderItem() {
        if (this.clickable) {
            return AtlButtonTemplate({
                variant: ButtonEnums.ButtonVariant.Action,
                size: ButtonEnums.ButtonSize.Small,
                buttonClasses: 'item-text',
                innerContent: html`<slot></slot>`,
                onClick: () => this.dispatchEvent(new AtlBreadcrumbClickEvent()),
            });
        }

        return (
            html`
                <span class="px-2 item-text" part="text span">
                    <slot></slot>
                </span>
            `
        )
    }

    renderIcon() {
        if (this.iconName) {
            return (
                html`
                    <atlantis-icon
                        part="icon"
                        name=${this.iconName || nothing}
                        iconClassName="atl-wc-breadcrumb-item-icon"
                        style="margin-left: 10px;"
                        .iconAriaSettings=${{ ariaHidden: true } as AtlAriaIconProps}
                    >
                    </atlantis-icon>
                `
            )
        }

        return nothing;
    }

    render() {
        return html`
            <div aria-current="page">
                <span id=${this.internalId} class="breadcrumbs-item breadcrumb-item ${classMap({ "active": this.active === true || !this.clickable })}">
                    ${this.renderIcon()}
                    ${this.renderItem()}
                </span>
            </div>
        `;
    }
}